/**
 * Productfoto's worden ZELF gehost: scripts/build-images.mjs verkleint elke Timmers-foto
 * naar WebP in public/img/<id>.webp (geserveerd vanaf de eigen Firebase-CDN — snel, altijd
 * warm, geen externe proxy die ons kan blokkeren, zoals eerder gebeurde met weserv).
 *
 * cdnImage zet een Timmers-URL om naar het lokale /img/<id>.webp als die bestaat (volgens
 * het manifest); ontbreekt 'ie, dan valt 'ie terug op de originele URL. Lokale assets
 * (/logo.png, /hero-*.jpg) en onbekende hosts blijven ongewijzigd.
 */
import manifest from "../../data/seed/image-manifest.json";

const LOCAL = new Set(manifest as string[]);
const HOST = "timmers.bakaglass.nl";

/** Maten blijven bestaan voor de call-sites; lokaal serveren we één scherpe WebP-maat. */
export const IMG = { thumb: 96, card: 420, hero: 960 } as const;

export interface CdnImageOpts {
  w?: number;
  h?: number;
  q?: number;
  fit?: "cover" | "inside";
}

/** Stabiele id uit een Timmers-URL: de bestandsnaam zonder extensie. */
function idOf(url: string): string {
  const last = (url.split("?")[0] ?? "").split("/").pop() ?? "";
  return last.replace(/\.[a-z0-9]+$/i, "");
}

export function cdnImage(url: string | undefined | null, opts: CdnImageOpts = {}): string {
  if (!url) return url ?? "";
  let host: string;
  try {
    host = new URL(url).host;
  } catch {
    return url; // relatieve/lokale URL → ongewijzigd
  }
  if (host !== HOST) return url;
  const id = idOf(url);
  if (!LOCAL.has(id)) return url; // niet lokaal → origineel
  // Kleine gevraagde breedte (winkelwagen, bestelgeschiedenis, cross-sell-tegels, ...) → de
  // aparte thumb-variant (scripts/build-images.mjs) i.p.v. steeds dezelfde 600px-kaartfoto.
  const useThumb = typeof opts.w === "number" && opts.w <= 150;
  return `/img/${id}${useThumb ? "-thumb" : ""}.webp`;
}
